import 'reflect-metadata';
export * from './component';
export * from './vuex';
export * from './sys';
